/**
 * Per-conversation cost breakdown API.
 *
 * Fetches the provider-reported, per-(model, provider) cost breakdown from the
 * usage ledger (backed by ``GET /conversations/{id}/cost-breakdown``). The
 * backend reconciles any still-pending streaming OpenRouter cost before
 * responding, so re-fetching a moment later fills in figures that were
 * ``pending`` on the first read.
 */

import { apiFetch } from "./client";
import type { CostBreakdownResponse } from "./types";

export async function fetchCostBreakdown(
  conversationId: string,
): Promise<CostBreakdownResponse> {
  return apiFetch<CostBreakdownResponse>(
    `/conversations/${conversationId}/cost-breakdown`,
  );
}
